import {fromBinary, toJson } from "@bufbuild/protobuf";
import { GenMessage } from "@bufbuild/protobuf/codegenv1";
import { map } from 'rxjs/operators';
import { AirSpaceBoundaryModel } from "src/app/models/air-space-boundary";
import { CoordinatePointModel } from "src/app/models/coordinate-point";
import { NavaidModel } from "src/app/models/navaid";
import { ProcedureModel } from "src/app/models/procedure";
import { AirSpaceBoundaryDTOListSchema } from "src/generatedProto/AirSpaceBoundaryDTOList_pb";
import { AirSpaceBoundaryDTOSchema } from "src/generatedProto/AirSpaceBoundaryDTO_pb";
import { CoordPointListSchema } from "src/generatedProto/CoordPointList_pb";
import { CoordPointSchema } from "src/generatedProto/CoordPoint_pb";
import { NavaidFileSchema } from "src/generatedProto/NavaidFile_pb";
import { NavaidListSchema } from "src/generatedProto/NavaidList_pb";
import { NavaidSchema } from "src/generatedProto/Navaid_pb";
import { ProcedureDTOListSchema } from "src/generatedProto/ProcedureDTOList_pb";
import { ProcedureDTOSchema } from "src/generatedProto/ProcedureDTO_pb";

export function protobufPipe<T>(classType: new (...args: any[]) => T) {
    return map((buffer: ArrayBuffer) => {
        // Get Schemas
        const schemas = getSchemasFromClass(classType);

        // Deserialize the wrapper message
        const protoList = fromBinary(schemas.listSchema, new Uint8Array(buffer));

        if (!protoList.entities || protoList.entities.length == 0) {
            return [];
        }

        const listEntries = getListEntriesKeys(protoList.entities[0], classType);

        // Access the list of entities and map them to JSON
        return protoList.entities.map((entity: any) => {
            const json = toJson(schemas.entitySchema, entity);
            const jsonWithEmptyLists = ensureEmptyLists(json, listEntries);

            const modelInstance = new classType();
            Object.assign(modelInstance, jsonWithEmptyLists);
 
            return modelInstance;
        });
    });
}


function getSchemasFromClass(classType: new (...args: any[]) => any) {
    if (classType === CoordinatePointModel) {
        return {
            listSchema: CoordPointListSchema,
            entitySchema: CoordPointSchema,
        };
    } else if (classType === NavaidModel) {
        return {
            listSchema: NavaidListSchema,
            entitySchema: NavaidSchema,
        };
    } else if (classType === ProcedureModel) {
        return {
            listSchema: ProcedureDTOListSchema,
            entitySchema: ProcedureDTOSchema,
        };
    } else if (classType === AirSpaceBoundaryModel) {
        return {
            listSchema: AirSpaceBoundaryDTOListSchema,
            entitySchema: AirSpaceBoundaryDTOSchema,
        };
    } else {
        throw new Error('Schema not found for the given class');
    }
    
}

function ensureEmptyLists(objectWithNulls: Object, listEntrieskeys: string[]): any {
    for (let listEntryKey of listEntrieskeys) {
        if (objectWithNulls[listEntryKey] === null || objectWithNulls[listEntryKey] === undefined) {
            objectWithNulls[listEntryKey] = [];
        }
    }

    return objectWithNulls;
}

function getListEntriesKeys(object: Object, classType: new () => any): string[] {
    const entries = Object.entries(object);

    const classInstance = new classType();
    
    const listEntriesKeys: string [] = [];
    for (let [key, value] of entries) {
        if (Array.isArray(value) && key in classInstance) {
            listEntriesKeys.push(key);
        }
    }

    return listEntriesKeys;
}

